const App = () =>
    import ('@/layout/AppMeeting.vue')
const Home = () =>
    import ('@/views/home/home.vue')
const Scheme = () =>
    import ('@/views/home/scheme.vue')

export default {
    path: '/',
    component: App,
    redirect: '/home',
    // sort: 1,
    children: [{
        path: '/home',
        component: Home
    },
    {
        path: '/url_scheme',
        component: Scheme
    }
]
}